import * as React from "react";

const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  return React.useSyncExternalStore(subscribeToViewport, readIsMobile, () => false);
}

function readIsMobile() {
  return window.innerWidth < MOBILE_BREAKPOINT;
}

function subscribeToViewport(onChange: () => void) {
  const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
  mql.addEventListener("change", onChange);
  return () => mql.removeEventListener("change", onChange);
}
